import _ from 'lodash'
import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './debugDialog.html'
import contentTemplateUrl from './debugDialog.content.html'
import contentMockTemplateUrl from './debugDialogMock.content.html'

/**
 * Epc Reader Simulator settings menu component
 *
 * @type {ngComponent}
 */
export const tmrDebugMenu = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrDebugMenuController',
}

/**
 * Controller of component {@link tmrDebugMenu}
 *
 * @type {ngController}
 */
export class tmrDebugMenuController {
  static ngType = 'controller'

  constructor($mdDialog) {
    'ngInject'
    Object.assign(this, { $mdDialog })
  }

  showDialog($event) {
    this.$mdDialog.show({
      templateUrl: process.env.includeDevel
        ? contentMockTemplateUrl
        : contentTemplateUrl,
      fullscreen: true,
      clickOutsideToClose: true,
      controller: process.env.includeDevel
        ? 'tmrDebugMenuContentMockController'
        : 'tmrDebugMenuContentController',
      controllerAs: '$ctrl',
      bindToController: true,
      targetEvent: $event,
      locals: {
        parent: this,
      },
      resolve: {
        antenna: /*@ngInject*/ (
          ActiveWorkstation,
          TmrNoActiveWorkstationError
        ) =>
          ActiveWorkstation.getAntennas().catch(err => {
            if (!(err instanceof TmrNoActiveWorkstationError)) throw err
          }),
      },
    })
  }
}

/**
 * Controller of dialog content defined in controller {@link tmrDebugMenuController}
 *
 * @type {ngController}
 */
export class tmrDebugMenuContentController extends tmrDialogController {
  constructor($mdDialog, $transitions, tmrTagTypes, TmrLocalStorage) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { tmrTagTypes, TmrLocalStorage })
  }

  $onInit() {
    super.$onInit()
    this.selectedEpcs = []
    this.epc = this.locals.parent.epc
    this.ignoreDeviceManageErrors = this.TmrLocalStorage.get(
      'ignoreDeviceManageErrors',
      false
    )
  }

  onEpcChange($event) {
    if ($event.key == 'Enter' && !$event.shiftKey && this.epc) {
      this.readEpc(this.epc)
      $event.preventDefault()
    }
  }

  onIgnoreDeviceManagerErrorsChange() {
    this.TmrLocalStorage.set(
      'ignoreDeviceManageErrors',
      this.ignoreDeviceManageErrors
    )
  }

  readEpc(text) {
    const epcs = text.split(/\n|,/).map(epc => epc.trim())
    const codeProperty =
      this.tmrTagTypes[this.antenna.antennas[0].rfidReader.$getTagType()]
        .codeProperty
    epcs.forEach(epc => {
      this.antenna.antennas[0].onMessageCallback({
        data: {
          antennaIdDb: this.antenna.antennas[0].id,
          [codeProperty]: epc,
        },
      })
    })
    this.locals.parent.epc = text
  }
}

/**
 * Controller of dialog content defined in controller {@link tmrDebugMenuController} when mock is active
 *
 * @type {ngController}
 */
export class tmrDebugMenuContentMockController extends tmrDebugMenuContentController {
  constructor(
    $mdDialog,
    $transitions,
    tmrTagTypes,
    $state,
    TmrEpcReaderSimulator,
    TmrLocalStorage,
    TmrDevelMockUtils,
    UserStorage
  ) {
    'ngInject'
    super($mdDialog, $transitions, tmrTagTypes)
    Object.assign(this, {
      $state,
      TmrEpcReaderSimulator,
      TmrLocalStorage,
      TmrDevelMockUtils,
      UserStorage,
    })
  }

  $onInit() {
    super.$onInit()
    this.TmrEpcReaderSimulator.init()
  }

  onEpcChange($event) {
    let epc = this.epc || this.epcsSearchText
    if ($event.key == 'Enter' && epc) this.readEpc(epc)
  }

  onReadRandomTagsChange() {
    this.TmrLocalStorage.set(
      'readRandomTags',
      this.TmrEpcReaderSimulator.readRandomTags
    )
  }

  getEpcs() {
    return this.TmrEpcReaderSimulator.epcs.filter(epc =>
      _.iIncludes(epc, this.epcsSearchText)
    )
  }

  rebuildMock() {
    this.TmrDevelMockUtils.mockStorage.clear()
    this.TmrDevelMockUtils.authenticatedUser = null
    this.UserStorage.clearUser()
    this.$state.reload('app')
  }
}
